import { useLayoutEffect, useState } from 'react'

import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'

import {
  SUPPORTED_DEFAULT_ALTERNATIVE_PAYMENT_METHODS,
  SUPPORTED_PAYPAL_FIRST_ALTERNATIVE_PAYMENT_METHODS,
} from 'modules/purchase/components/CheckoutSeparateMethods/shared/constants'
import { PaymentMethod } from 'modules/purchase/constants'

import { usePaymentPreferences } from './usePaymentPreferences'

export const useDefaultPaymentMethod = (
  alternativeMethods: PaymentMethod[],
) => {
  const { isKarmaPayPalPriorityTest } = useExperimentalFeatures()
  const { checkoutPaymentPriority } = usePaymentPreferences()

  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<PaymentMethod | null>(null)
  const [hasUserSelectedMethod, setHasUserSelectedMethod] = useState(false)

  useLayoutEffect(() => {
    if (hasUserSelectedMethod) {
      return
    }

    if (alternativeMethods.includes(PaymentMethod.UPI)) {
      setSelectedPaymentMethod(PaymentMethod.UPI)
      return
    }

    const paymentMethodsPriority =
      checkoutPaymentPriority ??
      (isKarmaPayPalPriorityTest
        ? SUPPORTED_PAYPAL_FIRST_ALTERNATIVE_PAYMENT_METHODS
        : SUPPORTED_DEFAULT_ALTERNATIVE_PAYMENT_METHODS)

    const selectedMethod = paymentMethodsPriority.find(
      (method) =>
        method === PaymentMethod.CREDIT_CARD ||
        alternativeMethods.includes(method),
    )

    setSelectedPaymentMethod(selectedMethod || PaymentMethod.CREDIT_CARD)
  }, [
    alternativeMethods,
    hasUserSelectedMethod,
    checkoutPaymentPriority,
    isKarmaPayPalPriorityTest,
  ])

  return {
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    setHasUserSelectedMethod,
  }
}
